import React, { useState, useEffect } from "react";
import styles from "./reqcard.module.css";
import axios from "axios";

const RequirementsCards = () => {
  const [requirements, setRequirements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user1 = sessionStorage.getItem("user");
  const user = JSON.parse(user1);

  useEffect(() => {
    fetchRequirements();
  }, []);

  const fetchRequirements = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        "https://golang.qspiders.com/api/student/get-requirementsdata",
        {
          headers: {
            Authorization: user?.q_q_users,
          },
        }
      );
      console.log(data.items);

      setRequirements(data?.items);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching requirements:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingContent}>
          <div className={styles.spinner}></div>
          <p>Loading requirements...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorContent}>
          <div className="error-box">
            <p className="error-title">Error loading requirements</p>
            <p className="error-message">{error}</p>
            {user.q_q_users && (
              <button
                onClick={() => window.location.reload()}
                className="retry-button">
                Retry
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <h1 className={styles.headerTitle}>Job Requirements</h1>
          <p className={styles.headerSubtitle}>
            Total Requirements: {requirements.length}
          </p>
        </div>

        <div className={styles.cardsGrid}>
          {requirements?.map((req) => (
            <div key={req.id} className={styles.requirementCard}>
              {/* Header */}
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{req.name}</h3>
                <p className={styles.designation}>
                  {req.interview_details.designation.name}
                </p>
              </div>

              {/* Content */}
              <div className={styles.cardContent}>
                {/* Interview Details */}
                <div className={styles.detailsSection}>
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}> Designation :</span>
                    <span
                      className={`${styles.detailValue} ${styles.badgeRounds}`}>
                      {req?.interview_details?.designation[0]?.name}
                    </span>
                  </div>
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}> Rounds :</span>
                    <span
                      className={`${styles.detailValue} ${styles.badgeRounds}`}>
                      {req?.details?.interviewrounds?.length}
                    </span>
                  </div>
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}> Location :</span>
                    {req.interview_details?.interview_location?.name != "" ? (
                      <span
                        className={`${styles.detailValue} ${styles.badgeLocation}`}>
                        {req?.interview_details?.interview_location?.name ||
                          "Not given"}
                      </span>
                    ) : (
                      <span>Not given</span>
                    )}
                  </div>
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}> Shift :</span>
                    {req?.details?.shift?.name != "" ? (
                      <span className={`${styles.detailValue}   `}>
                        {req?.details?.shift?.name || "Not given"}
                      </span>
                    ) : (
                      <span>Not given</span>
                    )}
                  </div>
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>
                      Mode of Interview :
                    </span>
                    <span className={styles.detailValue}>
                      {req?.details?.interview_type?.name || "Not given"}
                    </span>
                  </div>
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}> Bond : </span>
                    <span
                      className={`${styles.detailValue} ${styles.badgeBond}`}>
                      {req?.details?.bond?.boolbond ? `Yes` : "No"}
                    </span>
                  </div>
                  {req?.details?.bond?.boolbond && (
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}> Bond Years :</span>
                      <span
                        className={`${styles.detailValue} ${styles.badgeBond}`}>
                        {req.details.bond.bond_years} years
                      </span>
                    </div>
                  )}
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}> Deposit :</span>
                    <span
                      className={`${styles.detailValue} ${styles.badgeDeposit}`}>
                      {req?.details?.deposits?.bool_deposit ? `Yes` : "No"}
                    </span>
                  </div>
                  {req?.details?.deposits?.bool_deposit && (
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>
                        Deposit Amount :
                      </span>
                      <span
                        className={`${styles.detailValue} ${styles.badgeDeposit}`}>
                        ₹ {req.details.deposits.deposit_ammount}
                      </span>
                    </div>
                  )}

                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>
                      Certification submission :
                    </span>
                    <span
                      className={`${styles.detailValue} ${styles.badgeCert}`}>
                      {req?.details?.certificates != null
                        ? "Required"
                        : "Not Required"}
                    </span>
                  </div>
                  {req?.details?.certificates && (
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>
                        Certification :
                      </span>
                      <span
                        className={`${styles.detailValue} ${styles.badgeCert}`}>
                        {req?.details?.certificates.map((x) => {
                          return <span>{`${x.name}  `}</span>;
                        })}
                      </span>
                    </div>
                  )}
                  {req?.interview_details?.studentdetails && (
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Information:</span>

                      <span
                        className={`${styles.detailValue} ${styles.detailValue1}`}>
                        {req?.interview_details?.studentdetails}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {requirements.length === 0 && (
          <div className={styles.noData}>
            <p>No requirements found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequirementsCards;
